import type { SortDirection } from '@tanstack/react-table';

import { ReactComponent as ActiveSortIcon } from './active-sort-icon.svg';
import { ReactComponent as InactiveSortIcon } from './inactive-sort-icon.svg';

type Props = {
  active?: boolean;
  direction: SortDirection;
};

export const SortLabelIcon = ({ active, direction }: Props) => {
  if (!active) {
    return <InactiveSortIcon />;
  }

  return (
    <ActiveSortIcon
      style={{ transform: direction === 'desc' ? 'scaleY(-1)' : '' }}
    />
  );
};
